import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbtack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconThumbtack"><Path d="M9.5 2C8.11929 2 7 3.11929 7 4.5V6.10428C7 8.10754 6.1102 10.0073 4.57125 11.2898L4.17991 11.6159C4.06591 11.7109 4 11.8516 4 12V14.5C4 14.7761 4.22386 15 4.5 15H11.5V21.5C11.5 21.7761 11.7239 22 12 22C12.2761 22 12.5 21.7761 12.5 21.5V15H19.5C19.7761 15 20 14.7761 20 14.5V12C20 11.8516 19.9341 11.7109 19.8201 11.6159L19.4288 11.2898C17.8898 10.0073 17 8.10755 17 6.10428V4.5C17 3.11929 15.8807 2 14.5 2H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbtack;
